<div class="language-wrapper" [class.isOpen]="isOpenLanguages()">
  <div class="language-button">
    <button 
      data-testid="language-selector-btn"
      type="button"
      class="bottom-language-button button ghost" 
      (click)="onClickOpenLanguagePicker()"
    >
      <ui-inline-svg name="language" class="icon"></ui-inline-svg>
      {{ 'LANGUAGES.' + currentLanguage().toUpperCase() | transloco }}
    </button>
  </div>

  @if(isOpenLanguages()){
  <ul
    data-testid="language-options"
    class="language-list"
    [class.bottom]="pagePosition() === 'bottom'"
    [class.top]="pagePosition() === 'top'">
    @for (language of languages(); track language) {
    <li
      class="language-list-item"
      (click)="onChangeLanguage(language)">
      {{ 'LANGUAGES.' + language.toUpperCase() | transloco }}
    </li>
    }
  </ul>
  }
</div>
